import { FileType } from '@office-start/document-types';
/**
 * Used to generate the CSS classes for document sprite images found in DocumentIcons.scss
 * Note: Can use getFileTypeIconProps and IconButtonControl in most cases
 * @param fileType fileType to find icon file type for
 * @returns Corresponding file icon string
 */
export function getFileIconNameFromType(fileType) {
    switch (fileType) {
        case FileType.Word:
            return 'Word';
        case FileType.Excel:
            return 'Excel';
        case FileType.PowerPoint:
            return 'PowerPoint';
        case FileType.OneNote:
            return 'OneNote';
        case FileType.Pdf:
            return 'PDF';
        case FileType.Visio:
            return 'Visio';
        case FileType.Sway:
            return 'Sway';
        case FileType.Forms:
            return 'Forms';
        case FileType.Project:
            return 'Project';
        case FileType.ProjectOperations:
            return 'ProjectOperations';
        case FileType.Portfolio:
            return 'Portfolio';
        case FileType.Fluid:
        case FileType.FluidActivityBlueprint:
            return 'Fluid';
        case FileType.PowerBI:
            return 'PowerBI';
        case FileType.StreamsVideo:
        case FileType.Stream:
            return 'StreamsVideo';
        case FileType.List:
            return 'List';
        case FileType.PlayList:
            return 'PlayList';
        case FileType.PlayLists:
            return 'PlayLists';
        case FileType.ScreenRecording:
            return 'ScreenRecording';
        case FileType.Trello:
            return 'Trello';
        case FileType.NewsArticle:
            return 'NewsArticle';
        case FileType.Whiteboard:
            return 'Whiteboard';
        case FileType.MeetingNotes:
            return 'MeetingNotes';
        case FileType.Photos:
            return 'Photos';
        case FileType.MeetingObject:
            return 'MeetingObject';
        case FileType.Video:
            return 'Video';
        case FileType.Designer:
            return 'Designer';
        case FileType.Clipchamp:
            return 'Clipchamp';
        case FileType.Draft:
            return 'Draft';
        default:
            return 'Document';
    }
}
//# sourceMappingURL=getFileIconNameFromType.js.map